import * as actionTypes from "../actions/actionTypes";

const initialState = {
  incidentProcessing: false,
  incidentNumber: null,
  formType: false,
  apiErroMsg: null, // this is used to show error message in the UI
  // formType: 'create', // this is added if we need to have add, edit and view functionality
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.CREATE_SERVICE_NOW_START:
      return {
        ...state,
        incidentProcessing: true,
        apiErroMsg: null,
      };
    case actionTypes.SHOW_INCIDENT_LOADER:
        return {
          ...state,
          incidentProcessing: action.flag,
        };  
    case actionTypes.CREATE_SERVICE_NOW_SUCCESS:
      return {
        ...state,
        incidentNumber: action.incident,
        incidentProcessing: false,
        apiErroMsg: null,
      };
    case actionTypes.CREATE_SERVICE_NOW_FAILURE:
      return {
        ...state,
        incidentProcessing: false,
        apiErroMsg: action.error,
      };
    case actionTypes.RESET_INCIDENT_DETAILS:
      return {
        ...state,
        incidentProcessing: false,
        incidentNumber: null,
        apiErroMsg: null,
      };
    case actionTypes.INCIDENT_FORM_TYPE:
      return {
        ...state,
        formType: action.formType,
      };
    default:
      return state;
  }
};
export default reducer;
